import PropTypes from 'prop-types';

import {
  DisabledDefaultProps,
  DisabledPropTypes,
} from '@/common/proptypes/Base/Disabled.proptypes';
import {
  IsLoadingDefaultProps,
  IsLoadingPropTypes,
} from '@/common/proptypes/Base/IsLoading.proptypes';

export const ButtonInvoiceDefaultProps = {
  ...DisabledDefaultProps,
  ...IsLoadingDefaultProps,
  id: null,
  number: null,
  onDownloadInvoice: () => {},
};

export const ButtonInvoicePropTypes = {
  ...DisabledPropTypes,
  ...IsLoadingPropTypes,
  id: PropTypes.number,
  number: PropTypes.number,
  onDownloadInvoice: PropTypes.func,
};
